module.exports = __webpack_public_path__ + "img/logo.abea61df.png";